import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Card from '../components/Card'
import Paragraph from '../components/Paragraph'

const ImageWrap = styled.div`
  position: relative;
  cursor: pointer;
`

const Image = styled.img`
  width: 100%;
  position: ${props => props.zIndex === '0' ? 'relative' : 'absolute'};
  z-index: ${props => props.zIndex};
  top: 0;
  left: 0;
  opacity: ${props => props.shown ? '1' : '0'};
  transition: ${props => props.playing ? 'opacity 1s linear' : 'none'};
`

const Icon = styled.i`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  color: #fff;
  font-size: 2rem;
  z-index: 10;
`

const ResetButton = styled.button`
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;
`

@observer
export default class OpticNerveProgression extends Component {
  @observable step = 0
  @observable playing = false

  // store timeout id so we can clear it when resetting / restarting
  timeoutId = null

  @action
  increment = () => {
    if (this.step === 4) {
      this.playing = false
      this.timeoutId = null
    } else {
      this.step = this.step + 1
      this.timeoutId = setTimeout(this.increment, 1000)
    }
  }

  @action
  play = () => {
    // clear any existing timer before starting again
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }

    this.step = 0
    this.playing = true
    this.timeoutId = setTimeout(this.increment, 1000)
  }

  @action
  reset = () => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
    this.step = 0
    this.playing = false
  }

  render() {
    return (
      <Card>
        <Card.Pad>
          <Paragraph str="prose.opticNerveVideo" />
          <ImageWrap onClick={this.playing ? null : this.play}>
            <Image alt="" src="/images/optic-nerve-progression/1.png" zIndex="0" shown={true} playing={this.playing}/>
            <Image alt="" src="/images/optic-nerve-progression/2.png" zIndex="1" shown={this.step >= 1} playing={this.playing}/>
            <Image alt="" src="/images/optic-nerve-progression/3.png" zIndex="2" shown={this.step >= 2} playing={this.playing}/>
            <Image alt="" src="/images/optic-nerve-progression/4.png" zIndex="3" shown={this.step >= 3} playing={this.playing}/>
            <Image alt="" src="/images/optic-nerve-progression/5.png" zIndex="4" shown={this.step >= 4} playing={this.playing}/>
            <Icon className={this.playing ? "fas fa-sync fa-spin" : "fas fa-play"} />
          </ImageWrap>
          <ResetButton onClick={this.reset} disabled={this.step === 0 && !this.playing}>
            Reset
          </ResetButton>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OpticNerveProgression.js